// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".configuration{max-width:70%}@media(max-width:960px){.configuration{max-width:100%}}.cofiguration-tabs,.cofiguration-tabs .v-tabs-bar{background-color:hsla(0,0%,85%,.431)!important}.bg-light-grey-button{background:#f6f6f6!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
